import cn from "classnames";
import React from "react";
import HelpSvg from "../../../components/svgComponents/HelpSvg";
import MyNodeSvg from "../../../components/svgComponents/MyNodeSvg";
import NodeIcon from './../../../assets/icons/NodeIcon.png'

const NodeCard = ({ nodeName, nodeXbr, handleCardClick, isCardSelected }) => {
  return (
    <button
      type="button"
      onClick={() => {
        handleCardClick({ nodeId: nodeName, reward: nodeXbr });
      }}
      style={{
        boxSizing: 'border-box',
      }}
      className={cn(
        "px-6 pt-6 pb-8 w-full shadow-smallShadow rounded-2xl dark:bg-[#232234]",
        {
          "border border-deepBlue": isCardSelected(nodeName),
        }
      )}
    >
      <article className="w-full">
        <div className="mb-6 w-[63px] h-[52px]">
          <img src={NodeIcon} alt="" className="w-full" />
        </div>
        <div>
          <h4 className="text-black dark:text-white font-semibold text-2xl leading-7 w-full text-left">{`Node ${nodeName}`}</h4>
          <div className="flex gap-2 items-center">
            <div className="flex items-center gap-1">
              <p className="text-xs text-semiBlack dark:text-semiWhite leading-[14px] tracking-[0.015em]">
                Claimed from Node
              </p>
              <HelpSvg />
            </div>
            <span className="h-[1px] flex-1 border-b border-[#D1D9ED] dark:border-darkSlateBlue" />
            <p className="text-black dark:text-white text-xs leading-6">
              {`${Number(nodeXbr).toFixed(2)} XBR`}
            </p>
          </div>
        </div>
      </article>
    </button>
  );
};

export default NodeCard;
